import ROLES from "../../data/Roles";
import { EnvironmentsAPI } from "../../providers/EnvironmentsAPI";
import { AccessManager } from "./AccessManager";
import { EnvironmentStorage } from "./EnvironmentStorage";
import { Storage } from "./Storage";

export class UserStorage extends Storage {
  static getAccessToken() {
    return UserStorage.getItem("gestorAccessToken");
  }

  static setAccessToken(accessToken) {
    return UserStorage.setItem("gestorAccessToken", accessToken);
  }

  static getOcdpAccessToken() {
    return UserStorage.getItem("ocdpAccessToken");
  }

  static setOcdpAccessToken(accessToken) {
    return UserStorage.setItem("ocdpAccessToken", accessToken);
  }

  static isLogged() {
    return !!UserStorage.getAccessToken("gestorAccessToken");
  }

  static getUserType() {
    const user = UserStorage.getLoggedUser();
    return user?.user_type;
  }

  static getLoggedUser() {
    try {
      const accessToken = UserStorage.getAccessToken();

      if (!accessToken) return;

      return { ...JSON.parse(atob(accessToken.split(".")[1])) };
    } catch (err) {
      console.log(err);
      return null;
    }
  }
  
  static getOlgaLoggedUser() {
    try {
      const accessToken = UserStorage.getOcdpAccessToken();

      if (!accessToken) return;

      return { ...JSON.parse(atob(accessToken.split(".")[1])) };
    } catch (err) {
      console.log(err);
      return null;
    }
  }  

  static get isGodMode() {
    const userRole = UserStorage.getLoggedUser()?.role;
    return userRole === ROLES.SUPPORT;
  }

  static async loadPermissions() {
    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();
    const permissionsResponse = await EnvironmentsAPI.getPermissionsByType(
      holdingId
    );
    const permissions = permissionsResponse.getData([]);

    AccessManager.setPermissions(permissions);
  }
}
